import { NavLink } from 'react-router-dom';

/**
 * Lokale Reiter *innerhalb* eines Moduls (Auftrag §1: "lokale Reiter nur
 * noch innerhalb eines Moduls"). Generische Fassung des Musters, das heute
 * schon in `seiten/Fremdmodelle.tsx` (`<nav className="unterreiter">`)
 * verwendet wird - bewusst dieselben Klassennamen (`unterreiter`, `aktiv`)
 * aus `styles.css`, damit keine zweite optische Sprache fuer dieselbe Sache
 * entsteht. `styles.css` selbst wird dafuer nicht angefasst.
 */
export interface LocalTabEintrag {
  to: string;
  beschriftung: string;
  /** Wie `NavLink`s `end` - fuer den Index-Reiter eines Moduls. */
  end?: boolean;
}

export interface LocalTabsProps {
  eintraege: LocalTabEintrag[];
  ariaLabel?: string;
}

export function LocalTabs({ eintraege, ariaLabel = 'Modulreiter' }: LocalTabsProps) {
  return (
    <nav className="unterreiter" aria-label={ariaLabel}>
      {eintraege.map((eintrag) => (
        <NavLink
          key={eintrag.to}
          to={eintrag.to}
          end={eintrag.end}
          className={({ isActive }) => (isActive ? 'aktiv' : '')}
        >
          {eintrag.beschriftung}
        </NavLink>
      ))}
    </nav>
  );
}
